<template>
  <modal
    name="permit-invitation-details"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    @before-open="getData"
    height="auto"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header pb-2">
          <div
            class="
              d-flex
              align-items-center
              flex-wrap
              justify-content-between
              mb-2
            "
          >
            <p class="txt--off-white txt--ss txt--semi-bold mr-3">
              Permit Invitation
            </p>
            <div 
              v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true)"
              class="d-flex align-items-center"
            >
              <p class="txt--off-white txt--ss cursor-pointer mr-2" @click="cancelInvitation()" v-if="invitation_users.status!='completed'">
                Cancel Invitation
              </p>
              <p class="txt--off-white txt--ss">
                Customer Details
              </p>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <h2 class="txt--fslg mb-2">
              {{(invitation_users.user_id!='' && invitation_users.user_id!=null)?((invitation_users.first_name && invitation_users.first_name!='' )? invitation_users.first_name.charAt(0).toUpperCase()+invitation_users.first_name.slice(1) : "N/A")+" "+((invitation_users.last_name && invitation_users.last_name!='' )? invitation_users.last_name.charAt(0).toUpperCase()+invitation_users.last_name.slice(1) : "N/A"):invitation_users.email}}
            </h2>
            <input type="hidden" name="" id="invitation_link">
            
            <p v-if="invitation_users.status!='' && invitation_users.status!='completed'" class="txt--xs opacity--50 cursor-pointer" @click="copyInvitation(invitation_users.invitation_link)">Copy Invitation Link</p>
          </div>
          
          <div class="form-row">
            <div class="col-sm-6 mb-2">
              <div class="form-row align-items-center mb-2">
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">Date Sent</p>
                </div>
                <div class="col-7">
                  <p class="txt--fsxs text-truncate">{{(invitation_users.invitation_created_at!='' && invitation_users.invitation_created_at != null)? formatDate(invitation_users.invitation_created_at) :'N/A'}}</p>
                </div>
              </div>
              <div class="form-row align-items-center mb-2">
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">
                    Date Replied
                  </p>
                </div>
                <div class="col-7">
                  <p class="txt--fsxs text-truncate">
                    {{ invitation_users.replied_at != "" && invitation_users.replied_at != null
                              ? formatDate(invitation_users.replied_at)
                              : "N/A"}}
                  </p>
                </div>
              </div>
              <div class="form-row align-items-center mb-2">
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">
                    Date Completed
                  </p>
                </div>
                <div class="col-7">
                  <p class="txt--fsxs text-truncate">
                    {{ invitation_users.date_completed != "" && invitation_users.date_completed != null
                              ? formatDate(invitation_users.date_completed)
                              : "N/A"}}
                  </p>
                </div>
              </div>
              <div class="form-row align-items-center mb-2">
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">
                    Expiration Date
                  </p>
                </div>
                <div class="col-7">
                  <p class="txt--fsxs text-truncate">{{(invitation_users.expiration_date!='' && invitation_users.expiration_date!=null)?formatDate(invitation_users.expiration_date):'N/A'}}</p>
                </div>              
              </div>
              <div class="form-row align-items-center mb-2"
               v-if="invitation_users.status=='completed'"
              >
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">
                    Vehicle Allowance
                  </p>
                </div> 
                <div class="col-7">
                  <p class="txt--fsxs text-truncate">{{ invitation_users.vehicle_allowance }}</p>
                </div>                                
              </div>
            </div>
            <div class="col-sm-6 mb-2">
              <div class="form-row align-items-center mb-2">
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">Invited Email</p>
                </div>
                <div class="col-7">
                  <p class="txt--fsxs text-truncate1">
                    {{invitation_users.invited_email}} 
                      <!-- v-if="invitation_users.status!='completed'"  -->
                    <span 
                      v-if="invitation_users.status != 'completed' && (user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true))"
                      class="ml-2 cursor-pointer" 
                      @click="showEmailForm"
                    > 
                      <i class="fas fa-edit"></i>
                    </span> 
                  </p>
                </div>
              </div>
              <div class="form-row align-items-center mb-2">
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">Invited Claimed By</p>
                </div>
                <div class="col-7">
                  <p class="txt--fsxs text-truncate">{{invitation_users.claimed == 1 ? invitation_users.email : 'N/A'}}</p>
                </div>
              </div>
              <div class="form-row align-items-center mb-2">
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">Invited Claimed</p>
                </div>
                <div class="col-7">
                  <p class="txt--fsxs text-truncate">{{invitation_users.claimed == 1 ? 'Yes' : 'No'}}</p>
                </div>
              </div>
              <div class="form-row align-items-center">
                <div class="col-5 text-right">
                  <p class="txt--fsxs opacity--50 text-truncate">Status</p>
                </div>
                <div class="col-7">
                  <!-- <p class="txt--fsxs text-truncate">Sent</p> -->
                  <p class="txt--fsxs text-truncate txt--green">
                 {{ invitation_users.status && invitation_users.status!='' ? invitation_users.status.charAt(0).toUpperCase()+invitation_users.status.slice(1) : "N/A"}}
                    
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content__divider"></div>

        <div class="content__box__body" v-if="invitation_users.user_id!='' && invitation_users.status!='sent'">
          <div class="form-row align-items-center mb-2">
            <div class="col-sm-6 mb-1">
              <p class="txt--off-white txt--ss txt--semi-bold mr-3">
                Selections
              </p>
            </div>
            <div class="col-sm-6 mb-1">
              <p class="txt--off-white txt--fsxs mr-3">Assign Permit</p>
            </div>
          </div>
          
          <div class="form-row align-items-center mb-2" 
              v-for="(p, index) in invitation_property_choices"
              :key="index"          
          >
            <div class="col-sm-6 mb-2">
              <p class="txt--ss">
                <span class="txt--off-white mr-2">{{index+1}}</span>
               {{p.property_name}}
              </p>
            </div>
            <div class="col-sm-6 mb-2" v-if="Object.keys(permit_list).length > 0">
              <model-list-select
                  :list="permit_list[p.property_id]"
                  v-model="choosenPermitId"
                  option-value="permit_id"
                  option-text="permit_name"
                  placeholder="Select permit"
                  class="custom-vue-select"
                >
                </model-list-select>
            </div>

            <div class="col-sm-6 mb-2" v-if="p.property_id==selected_property_id">

               <p class="txt--ss">
               {{selected_permit_name}}
              </p>
              
            </div>
          </div>

          <div class="form-row align-items-center mb-2" v-if="all_permit_list.length>0">
            <div class="col-sm-6 mb-2">
              <p class="txt--ss">
               Custom Selection
              </p>
            </div>
            <div class="col-sm-6 mb-2" v-if="Object.keys(all_permit_list).length > 0">
              <!-- <model-list-select
                  :list="all_permit_list"
                  v-model="customPermitId"
                  option-value="permit_id"
                  option-text="permit_name"
                  placeholder="Select permit"
                  class="custom-vue-select"
                >
                </model-list-select> -->
                <multiselect
                  class="multi-select-input"
                  v-model="customPermitId"
                  :options="all_permit_list"
                  :multiple="false"
                  :close-on-select="true"
                  group-values="permits"
                  group-label="poperty"
                  :group-select="true"
                  placeholder="Select Permit"
                  track-by="permit_id"
                  label="name"
                >
                  <span slot="noResult">Oops! No permit found</span>
                  <template slot="tag" slot-scope="{ option, remove }"
                    ><span class="multiselect__tag">
                      <span>{{ option.poperty_name + " - " + option.name }}</span>
                      <i
                        aria-hidden="true"
                        tabindex="1"
                        class="multiselect__tag-icon"
                        @click="remove(option)"
                      ></i> </span
                  ></template>
                </multiselect>

            </div>
          </div>
          <div class="form-row align-items-center mb-2" v-else-if="!custom_property">
            <div class="col-sm-6 mb-2">
              <p class="txt--ss">
               Custom Selection
              </p>
            </div>
            <div class="col-sm-6 mb-2">

               <p class="txt--ss">
               {{selected_permit_name}}
              </p>
              
            </div>
          </div>
          <!-- <div class="form-row align-items-center mb-2">
             <div class="col-sm-6 mb-1">
                <p>Vehicle Allowance</p>
              </div>
              <div class="col-6">
                <p class="txt--ss text-truncate">{{ invitation_users.vehicle_allowance }}</p>
              </div>
          </div>  -->
          <div v-if="Object.keys(customPermitId).length>0 || Object.keys(choosenPermitId).length>0" class="form-row align-items-center mb-2">
            <div class="col-sm-12 mb-2">
              <Text-area
                label="Your Custom Message (optional)"
                v-model="custom_message"
                :value="custom_message"
                :rows="5"
                :charRequired="false"
              />
              <!-- <Text-area
                label="Reason for custom selection (optional)"
                v-model="custom_message"
                :value="custom_message"
                :rows="5"
                :charRequired="false"
              /> -->
            </div>
          </div>
            <!-- Allow Vehicle Section -->
          <div class="col-sm-12" v-if="invitation_users.status=='replied'">
            <div class="form-group">
              <label class="txt--xs txt--off-white mb-2 mr-2">Allow Vehicles</label>
              <ul class="top__filter__ul top__filter__ul--btn">
                <li
                  :class="{ active: allow_all_vehicle }"
                  @click="setVehicleAllowance(true)"
                >
                  Allow All
                </li>
                <li
                  :class="{ active: !allow_all_vehicle }"
                  @click="setVehicleAllowance(false)"
                >
                  Allow Selected
                </li>
              </ul>
              <div v-if="!allow_all_vehicle">
                <label class="txt--xs txt--off-white">Select Number of Vehicles</label>
                <input
                  type="text"
                  placeholder="Enter Number of Vehicles To Be Allowed"
                  @keypress="checkNumber"
                  class="textInputField"
                  v-model="vehicle_allowance"
                />
              </div>
            </div>
          </div>
         <div class="d-flex justify-content-center flex-wrap pt-4"  v-if="invitation_users.status=='completed'">
            <ButtonWithSpinner
              class="button button--primary button--sm mr-3 mb-2"
              @click="cancelResendInvitation()"
              :disabled="button.disabled"
              :loading="button.loading"
              :success="button.success"
            >
              Cancel And Resend</ButtonWithSpinner
            >
         </div>

            <!-- v-if="invitation_users.status!='completed' && invitation_users.user_availibility" -->
          <div 
            class="d-flex justify-content-center flex-wrap pt-4"  
            v-if="invitation_users.status!='completed' && invitation_users.user_availibility && (user_role == 'commercial' || (user_role == 'operator' && access_list.permit_access_write == true))"
          >
            <ButtonWithSpinner
              class="button button--primary button--sm mr-3 mb-2"
              @click="assignPermit()"
              :disabled="button.disabled"
              :loading="button.loading"
              :success="button.success"
            >
              Assign</ButtonWithSpinner
            >
            <button
              type="button"
              @click="closeModal()"
              class="button button--outline button--sm mb-2"
            >
              Cancel
            </button>
          </div>
          <div v-else class="property__header__text text-danger text-center">
            You are not authorized to make any changes.
          </div>

          <div  class="d-flex justify-content-center flex-wrap pt-4" v-if="!invitation_users.user_availibility">
            <input
                  type="text"
                  placeholder="Enter Email"
                  class="textInputField"
                  v-model="reassign_user"
            /><br><br><br>
            <ButtonWithSpinner
              class="button button--primary button--sm mr-3 mb-2"
              @click="reAssignUser"
            >
              Assign another user</ButtonWithSpinner
            >
          </div>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import { ModelSelect, ModelListSelect } from "vue-search-select";
import ButtonWithSpinner from "@/components/Button";
import Textarea from "@/components/Textarea";
export default {
  name: "PermitInvitationDetails",
  components: {
    ModelListSelect,
    ButtonWithSpinner,
     "Text-area": Textarea,
  },
  data() {
    return{
      invitation_id: '',
      invitation_users: {},
      invitation_property_choices: [],
      property_list:[],
      permit_list:[],
      choosenPermitId:{},
      customPermitId: {},
      button: {
        loading: false,
        success: false,
        disabled: false,
      },
      all_permit_list: [],
      invitation_user_details_source:"",
      selected_property_id:"",
      selected_permit_name:"",
      selected_permit_id:"",
      allow_all_vehicle:true,
      vehicle_allowance:'',
      custom_property: false,
      custom_message: "",
      reassign_user:'',
      user_role:    '',
      access_list:  {},
    }
  },
  watch: {
    customPermitId: function(val) {
      if(Object.keys(val).length > 0) {
        this.choosenPermitId = {};
      }
    },
    choosenPermitId: function(val) {
      if(Object.keys(val).length > 0) {
        this.customPermitId = {};
      }
      else {
        this.custom_message = '';
      }
    }
  },
  created()
  {
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list"));
  },
  methods: {
    formatDate(date) {
      if(date) {
        return this.$moment(date).format('lll');
      }
      else {
        return 'N/A';
      }
    },
     resetData() {
      this.invitation_id = "";
      this.invitation_users = {};
      this.invitation_property_choices = [];
      this.property_list = [];
      this.permit_list = [];
      this.choosenPermitId = {};
      this.customPermitId = {};   
      this.button.loading = false;
      this.button.success = false;
      this.button.disabled = false;
      this.invitation_user_details_source = "";
      this.selected_property_id = ""; 
      this.selected_permit_name = ""; 
      this.selected_permit_id = "";  
      this.all_permit_list = []; 
      this.custom_property = false;
    },
    getData(e) {
      this.resetData();
      this.invitation_property_choices =  e.params.invitation_users.property_choices;
      if ('permit_details' in e.params.invitation_users)
      {
        this.selected_property_id = (e.params.invitation_users.permit_details.property_id!=null)?e.params.invitation_users.permit_details.property_id:"";
        this.selected_permit_name = (e.params.invitation_users.permit_details.name!=null)?e.params.invitation_users.permit_details.name:"";
        this.selected_permit_id = (e.params.invitation_users.permit_details.permit_id!=null)?e.params.invitation_users.permit_details.permit_id:"";

        this.custom_property = false;
        this.invitation_property_choices.map((val) => {
          console.log(val.property_id);
          if(val.property_id == this.selected_property_id) {
            this.custom_property = true;
          }
        });
      }
      this.invitation_users = e.params.invitation_users;
      this.invitation_id = e.params.invitation_id;
      if(this.invitation_users.status == 'replied') {
        this.getPropertyPermitList();
        this.getAllPermitList();
      }
    },
    closeModal() {
      this.choosenPermitId = '';
      this.$modal.hide("permit-invitation-details");
    },
    getPropertyPermitList() {
      let property_list = [];
      this.invitation_users.property_choices.map((val)=> {
        property_list.push(val.property_id);
      });

      this.axios.post(window.hostname+'/api/auth/invitation/permit-list',{
        'property_list': property_list,
        'invitation_id': this.invitation_id
      })
      .then(res=> {
        if(res.data.status){
          this.permit_list = res.data.data;
        }
        else {
          this.permit_list = [];
        }
      })
      .catch(err=> {
        this.permit_list = [];
      })
    },
    assignPermit() {
      let custom_selection = false;
      let selected_permit_id = '';
      if(Object.keys(this.choosenPermitId).length> 0) {
        custom_selection = false;
        selected_permit_id = this.choosenPermitId.permit_id;
      }
      else if(Object.keys(this.customPermitId).length>0){
        custom_selection = true;
        selected_permit_id = this.customPermitId.permit_id;
      }
      else {
        this.$toasted.show("Please select at least one permit!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      let formData = {
        invitation_id: this.invitation_id,
        user_id: this.invitation_users.user_id,
        permit_id: selected_permit_id,
        custom_selection: custom_selection ? 1 : 0,
        vehicle_allowance:this.vehicle_allowance,
        custom_message: this.custom_message,
      }
      this.button.loading = true;
      this.button.disabled = true;
      this.button.success = false;

      this.axios.post(window.hostname+'/api/auth/invitation/assign-permit',formData)
      .then(res=> {
        this.button.loading = false;
        this.button.disabled = false;
        if(res.data.status) {
          this.$toasted.show(res.data.message,{
            icon: 'check-circle',
            className: 'success-class'
          });
          this.button.success = true;

          this.$nextTick(()=> {
            this.button.success = false;
          });
          this.$emit("update_invitation_list",true);
          this.resetData();       
          this.closeModal();
        }
        else {
          this.$toasted.show(res.data.message,{
            icon: 'times-circle',
            className: 'error-class'
          });
        }
      })
      .catch(err=> {
        console.log(err);
      })
    },
    cancelInvitation(){

      const CancelToken = this.axios.CancelToken;
      this.invitation_user_details_source = CancelToken.source();

      let invitation_id = this.invitation_users.invitation_id;
      let email = this.invitation_users.email;

      this.$swal({
        title: "Are you sure?",
        text: "Do you want to cancel this invitation?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {

          this.axios
            .post(window.hostname + "/api/auth/invitation/cancel", {
                device_type: 1,
                invitation_id:invitation_id,
                email:email,
              
              },
              {
                cancelToken: this.invitation_user_details_source.token,
              }  
            )
            .then((res) => {
              if (res.data.status) {

               this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });  
                
                this.$emit("update_invitation_list",true);
                this.resetData();
                this.closeModal();
              
              }
              else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            
            })
            .catch((err) => {

              if(this.axios.isCancel(err)){
                return;
              }
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
              
            
            });    
        }
      });

    },
    cancelResendInvitation(){
      let invitation_id = this.invitation_users.invitation_id;
      let email = this.invitation_users.email;

      this.$swal({
        title: "Are you sure?",
        text: "Do you want to cancel and resend this invitation?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.cancelApiCall(invitation_id,email);
        }
      });
    },
    async cancelApiCall(invitation_id,email) {
      const { value: selected_data } = await this.$swal({
        title: "Cancel and Resend?",
        html:
          "Do you want to cancel and resend the invitation?" +
          "<br>" +
          `
        <div class="row justify-content-center">
          <div class="col-sm-4 mt-2">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="cancel_only" class="custom-control-input" name="cancel_type" value="cancel_only"><label for="cancel_only" class="custom-control-label">Cancel</label>
            </div>
          </div>
          <div class="col-sm-8 mt-2">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" id="cancel_resend" class="custom-control-input" name="cancel_type" value="cancel_resend"><label for="cancel_resend" class="custom-control-label">Cancel & Resend</label>
            </div>
          </div>
        </div>`,
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          if (document.querySelector('input[name="cancel_type"]:checked')) {
            let selected_value = document.querySelector(
              'input[name="cancel_type"]:checked'
            ).value;

            if (selected_value) {
              return selected_value;
            } else {
              this.$toasted.show(
                "Please select one of the options listed above!",
                {
                  icon: "times-circle",
                  className: "error-class",
                }
              );
              return false;
            }
          } else {
            this.$toasted.show(
              "Please select one of the options listed above!",
              {
                icon: "times-circle",
                className: "error-class",
              }
            );
            return false;
          }
        }
      });

      if(selected_data !== undefined) {
        this.axios
        .post(window.hostname + "/api/auth/invitation/cancel-resend", {
            device_type: 1,
            user_id: this.invitation_users.user_id,
            invitation_id:invitation_id,
            email:email,
            permit_id:this.selected_permit_id,    
            resend : selected_data == 'cancel_resend' ? 1 : 0,           
        })
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });  
            this.$emit("update_invitation_list",true);
            this.resetData();
            this.closeModal();
          }
          else {
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
            return;
          }
        })
        .catch((err) => {
          this.$toasted.show(err.response.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
        }); 
      }
    },
    copyInvitation(invitation_link) {
      let testingCodeToCopy = document.querySelector("#invitation_link");
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.setAttribute("value", invitation_link);
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.$toasted.show("Copied text!", {
            icon: "check-circle",
            className: "success-class",
          });
        }
      } catch (err) {
        this.$toasted.show("Oops! unable to copy.", {
          icon: "times-circle",
          className: "error-class",
        });
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    async showEmailForm() {
      const { value: new_email } = await this.$swal({
        title: "Enter Email",
        input: "text",
        inputValue: this.invitation_users.invited_email,
        inputPlaceholder: "Enter Email",
        showCancelButton: true,
        inputValidator: (value) => {
          console.log(value)
          if (!value) {
            return "Please provide an email!";
          }

          var emailTest = window.regularExpressions.email.test(value);

          if(!emailTest) {
            return "Please provide a valid Email!";
          }
        }
      });
      console.log(new_email);
      if(new_email) {
        this.invitation_users.invited_email = new_email;
        await this.axios.post(window.hostname+'/api/auth/invitation/invited-email-update',{
          invitation_id: this.invitation_users.invitation_id,
          email: this.invitation_users.email,
          new_email: this.invitation_users.invited_email
        })
        .then(res=> {
          if(res.data.status) {
            
            this.$toasted.show(res.data.message,{
              icon:'check-circle',
              className: 'success-class'
            });
            this.$emit("update_invitation_list",true);
          }
          else {
            this.$toasted.show(res.data.message,{
              icon: 'times-circle',
              className: 'error-class'
            });
          }
        })
        .catch(err=> {
          console.log(err)
        })
      }
    },
    setVehicleAllowance(status){
      this.allow_all_vehicle=status;
      if(this.allow_all_vehicle) {
        this.vehicle_allowance = '';
      }
    },
    checkNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      return true;
    },
    getAllPermitList() {
      this.axios
        .post(window.hostname + "/api/auth/permit/list", {
          device_type: 1,
          commercial: 1,
          all:1,
        })
        .then((res) => {
          if (res.data.status) {
            let all_permit_list = res.data.data.permit_list;      
            
            all_permit_list.forEach((item, index)=>{
              //console.log(item);
             

             /*  if(this.options.some(option => option.poperty == item.property_name)) {
                console.log("item.property_name>>>>>>"+item.property_name);
              } */
              var index_item = this.all_permit_list.map(function(o) { return o.poperty; }).indexOf(item.property_name);
              if (index_item>-1){
                //console.log(">>>>>>"+index_item);
                 this.all_permit_list[index_item].permits.push(
                      {      
                          permit_id : item.permit_id, 
                          name : item.permit_name, 
                          poperty_name : item.property_name,  
                          property_id :  item.property_id,               
                      }
                 );
              }
              else{

                  this.all_permit_list.push({
                      poperty: item.property_name,
                      permits: [
                        {
                          permit_id : item.permit_id, 
                          name : item.permit_name, 
                          poperty_name : item.property_name,
                          property_id :  item.property_id,
                        },
                      ],
                    
                    });
              }
            });
          } else {
            this.all_permit_list = [];
          }
        })
        .catch((err) => {
          this.all_permit_list = [];
          console.log(err);
        });
    },
    reAssignUser(){
      console.log(this.invitation_users.invitation_id);
      console.log(this.invitation_users.user_id)
      this.axios.post(window.hostname+'/api/auth/invitation/checkuser-assignee',{
        invitation_id:this.invitation_users.invitation_id,
        email:this.reassign_user,
        user_id:this.invitation_users.user_id
      }).then((res)=>{
        if(res.data.status) {
          this.$toasted.show(res.data.message,{
            icon: 'check-circle',
            className: 'success-class'
          });
          this.button.success = true;

          this.$nextTick(()=> {
            this.button.success = false;
          });
          this.$emit("update_invitation_list",true);
          this.resetData();       
          this.closeModal();
        }
        else {
          this.$toasted.show(res.data.message,{
            icon: 'times-circle',
            className: 'error-class'
          });
        }
      })
    }
  },
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
.text-truncate1{
  overflow: hidden;
  text-overflow: ellipsis;
  line-break:anywhere;
}
</style>